import React from "react";
import PropTypes from "prop-types";
import { Panel } from "react-instantsearch-dom";

import CustomToggle from "components/base/Toggle";

const Header = ({
  title,
  toggle,
  checked,
  valueKey,
  leftToggleLabel,
  rightToggleLabel,
  helpText,
  onChange,
  toolTipClassName,
  isCollapsed = false,
}) => {
  if (toggle) {
    return (
      <div className="flex justify-between gap-2 flex-wrap relative">
        <div className="min-w-0">{title}</div>

        <CustomToggle
          checked={checked}
          valueKey={valueKey}
          leftLabel={leftToggleLabel}
          rightLabel={rightToggleLabel}
          helpText={helpText}
          onChange={onChange}
          toolTipClassName={toolTipClassName}
        />
      </div>
    );
  }

  return <div className="min-w-0">{title}</div>;
};

const CustomPanel = ({
  title,
  toggle,
  checked,
  valueKey,
  leftToggleLabel,
  rightToggleLabel,
  helpText,
  onChange,
  toolTipClassName,
  isCollapsed,
  id,
  children,
}) => {
  const handleChange = (value, valueKey) => {
    onChange(value, valueKey);
  };

  return (
    <div id={id}>
      <Panel
        header={
          <Header
            title={title}
            toggle={toggle}
            checked={checked}
            valueKey={valueKey}
            leftToggleLabel={leftToggleLabel}
            rightToggleLabel={rightToggleLabel}
            helpText={helpText}
            toolTipClassName={toolTipClassName}
            isCollapsed={isCollapsed}
            onChange={handleChange}
          />
        }
      >
        {children}
      </Panel>
    </div>
  );
};

CustomPanel.propTypes = {
  title: PropTypes.node,
  toggle: PropTypes.bool,
  checked: PropTypes.bool,
  valueKey: PropTypes.string,
  helpText: PropTypes.string,
  onChange: PropTypes.func,
  isCollapsed: PropTypes.bool,
};

CustomPanel.defaultProps = {
  title: "",
  toggle: false,
  checked: true,
  valueKey: "",
  helpText: "",
  onChange: () => {},
};

export default CustomPanel;
